import { faSearch } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Input } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, generatePath } from 'react-router-dom';
import { setPacientesKeyword } from '../../../state/actions/creators/pacientes.actioncreator';
import { ROUTE_PACIENTES_LIST } from '../../../routes.constants';


export default function SearchBar() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [filter, setFilter] = useState('');
  const keywordState = useSelector(state => state.pacientesWorkspace.keyword);

  useEffect(() => {
    setFilter(keywordState);
  }, [keywordState]);

  const search = () => {
    dispatch(setPacientesKeyword(filter));
    history.push(generatePath(ROUTE_PACIENTES_LIST));
  };

  return (
    <div className="headerSearchBar">
      <FontAwesomeIcon className="searchIcon" icon={faSearch} size="2x" onClick={search} />
      <Input
        className="searchInput"
        value={filter}
        placeholder="Buscar..."
        onChange={event => setFilter(event.target.value)}
        onPressEnter={() => search()}
      />
    </div>
  );
}
